import { render } from "./LiferayCampaign.vue?vue&type=template&id=4c6ba79b&scoped=true"
import script from "./LiferayCampaign.vue?vue&type=script&lang=js"
export * from "./LiferayCampaign.vue?vue&type=script&lang=js"

import "./LiferayCampaign.vue?vue&type=style&index=0&id=4c6ba79b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6ba79b"]])

export default __exports__